import { makeStyles } from "@mui/styles";
import React from "react";
import ContainerMain from "../../../commonStyles/container/containerMain/containerMain";
import logoMb from "../../../assets/logo/logo-mb.png";
import { colors } from "../../../colors/colors";
import PhoneTalk from "src/assets/iconsSvg/phoneTalk";
import LanguageIcon from "../../../assets/iconsSvg/language";
import ArrowDownLanguage from "src/assets/iconsSvg/arrowLanguage";
import { useNavigate } from "react-router-dom";
import PATH from "src/routes/route-path";
import { MB_LINK } from "src/const";
import { FontSize } from 'src/const/font';
import { handlePhoneCall } from "src/utils/checkMobileWebView";
const useStyles = makeStyles((theme) => {
  return {
    header: {
      borderBottom: `2px solid ${colors.line.grayDark}`,
      background: colors.white,
      position: "fixed",
      top: 0,
      right: 0,
      left: 0,
      width: "100%",
      zIndex:999,
      [theme.breakpoints.down("md")]: {
      },
    },
    containerDad: {
      ...theme.custom.flexBox.flexBetWeen,
      padding: "16px 0",
      lineHeight: "20px",
      fontSize: "14px",
      colors: colors.blacks.textHeader,
      [theme.breakpoints.down("md")]: {
        padding: "3px 0",
      },
    },
    logo: {
      cursor: "pointer",
    },
    containerRight: {
      display: "flex",
      alignItems: "center",
    },
    phone: {
      background: colors.background.blueButton,
      padding: "8px",
      borderRadius: "16px",
      color: colors.white,
      fontWeight: 800,
      ...theme.custom.flexBox.flexAlignItemsCenter,
      [theme.breakpoints.down("md")]: {
        fontSize:FontSize.sub.default
      },

    },
    language: {
      ...theme.custom.flexBox.flexAlignItemsCenter,
    },
    textLanguage: {
      margin: "0 8px",
    },
    line: {
      width: "1px",
      height: "18px",
      background: "rgba(17, 40, 67, 1)",
      margin: "0 24px",
      opacity: "0.16",
    },
    catalogItem: {
      marginRight: "16px",
      cursor: "pointer",
      [theme.breakpoints.down("md")]: {},
    },
    margin0: {
      marginRight: "0",
    },
  };
});
interface IPropsHeader {
}
const HeaderHome = (props: IPropsHeader) => {
  const classes = useStyles();
  
  return (
    <div className={classes.header} id={"app-header"}>
      <ContainerMain>
        <div className={classes.containerDad}>
          <a href={MB_LINK} className={classes.logo}>
            <img style={{ width: "94px" }} src={logoMb} alt="" />
          </a>
          <div className={classes.containerRight}>
            <div className="">
              <a
                href={'tel: 024 2229 8888'}
                className={classes.phone}
                onClick={(e) => {
                  e.preventDefault();
                  handlePhoneCall('024 2229 8888');
                }}
              >
                <PhoneTalk />
                <div style={{ marginLeft: "8px" }}>024 2229 8888</div>
              </a>
            </div>
          </div>
        </div>
      </ContainerMain>
    </div>
  );
};

export default HeaderHome;
